export default "__VITE_ASSET__DUHOjmXH__"